import Text from '@/components/view/atoms/text/Text'

interface Props {
  value: number
  onChange(value: number): void
  color: string
}

const Slider = ({ value, onChange, color }: Props) => {
  return (
    <span className='flex w-full items-center gap-2'>
      <input
        type='range'
        min={0}
        max={0.9}
        step={0.05}
        value={value}
        onChange={(e) => onChange(parseFloat(e.target.value))}
        className='bg-fill-secondary h-2 w-full cursor-pointer appearance-none rounded-lg'
        style={{ accentColor: color }}
      />
      <span className='text-size-24 ml-1 shrink-0 leading-none font-bold' style={{ color }}>
        {(value * 100).toFixed(0)}
      </span>
      <Text>%</Text>
    </span>
  )
}
export default Slider
